import React, { FC } from 'react';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import Dropdown, { TDropdownProps } from '../../../@shared/filters/components/dropdown';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import { NewsListingModel } from '../../models/newsListing.model';
import { useNavigate } from 'react-router';
import { QueryParamsConst } from '../../../../constants/query-params.constants';
import { TNewsListingFilter, TSelectedNewsFilters } from '../../types/newsListing.types';
import { useTranslation } from 'react-i18next';
import { googleClickDropdownEvent } from '../../../../utils/analytics';
import {
  NEWS_FILTER1_FILTER_TITLE_DICTIONARY_TERM,
  NEWS_LINE_FILTER_TITLE_DICTIONARY_TERM,
  NEWS_TYPE_FILTER_TITLE_DICTIONARY_TERM,
  NEWS_YEAR_FILTER_TITLE_DICTIONARY_TERM,
} from '../../../../constants/newsListnig.constatnts';

const DesktopFilter: FC<{ model: NewsListingModel; selectedFilters: TSelectedNewsFilters }> = ({ model, selectedFilters }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { YEAR, TYPE, LINE, FILTER1 } = QueryParamsConst;

  const getDropdownOptions = (filter?: TNewsListingFilter, titleDictionaryKey?: string): TDropdownProps['dropdownOptions'] => {
    if (!filter) return [];
    return [
      { id: filter.value, title: t(titleDictionaryKey || '') },
      ...(filter?.tags?.map((tag) => ({ id: tag.id?.toString(), title: tag.value })) || []),
    ];
  };

  const dropDownsProps = [
    {
      filter: model.findFilterByName('year'),
      queryKey: YEAR,
      titleDictionaryKey: 'cnhi-news-all-years',
      id: 'year-dropdown',
      dataLayerTitle: NEWS_YEAR_FILTER_TITLE_DICTIONARY_TERM,
    },
    {
      filter: model.findFilterByName('line'),
      queryKey: LINE,
      titleDictionaryKey: 'cnhi-news-all-lines',
      id: 'line-dropdown',
      dataLayerTitle: NEWS_LINE_FILTER_TITLE_DICTIONARY_TERM,
    },
    {
      filter: model.findFilterByName('type'),
      queryKey: TYPE,
      titleDictionaryKey: 'cnhi-news-all-types',
      id: 'type-dropdown',
      dataLayerTitle: NEWS_TYPE_FILTER_TITLE_DICTIONARY_TERM,
    },
    {
      filter: model.findFilterByName('filter1'),
      queryKey: FILTER1,
      titleDictionaryKey: 'cnhi-news-all-filter1',
      id: 'filter1-dropdown',
      dataLayerTitle: NEWS_FILTER1_FILTER_TITLE_DICTIONARY_TERM,
    },
  ];

  const shouldShowResetFilter =
    selectedFilters[YEAR] !== '' || selectedFilters[LINE] !== '' || selectedFilters[TYPE] !== '' || selectedFilters[FILTER1] !== '';
  const resetFilterCTA = shouldShowResetFilter && (
    <span className="news-listing-with-filter__reset" onClick={() => model.resetFilter(navigate)}>
      <DictionaryTerm keyword="cnhi-news-reset-filters" />
      <Icon iconName="action-refresh" size={iconSize['dsk']} color="primary" />
    </span>
  );

  return (
    <div className="news-listing-with-filter--dsk">
      <div className="news-filter">
        <div className="news-filter__dropdown-wrapper">
          {dropDownsProps.map(({ filter, queryKey, id, titleDictionaryKey, dataLayerTitle }) => {
            const options = getDropdownOptions(filter, titleDictionaryKey);
            if (!options?.length || filter.hidden) return null;
            return (
              <Dropdown
                key={id}
                dropdownOptions={options}
                id={id}
                handleOptionClick={(ind) => {
                  model.updateQueryByKey(navigate, queryKey, ind === 0 ? '' : (options?.[ind].id as string));
                  googleClickDropdownEvent(t(dataLayerTitle), options[ind].title as string);
                }}
                selectedOptionInd={(filter?.tags?.findIndex((_) => _.id?.toString() === selectedFilters[queryKey]) ?? -1) + 1}
              />
            );
          })}
        </div>
        {resetFilterCTA}
      </div>
    </div>
  );
};

export default DesktopFilter;
